const DEFAULT_MAX_STEPS = 18
const FLOW_ID_GLOBAL_KEY = '__PINPAD_FLOW_ID__'
const FLOW_LOGS_ENABLED_GLOBAL_KEY = '__PINPAD_FLOW_LOGS_ENABLED__'
const FLOW_LOGS_ENABLED_STORAGE_KEY = 'pinpad-flow-logs-enabled'

const PHASE_ICONS = {
  INIT: '🔵',
  SERIAL: '🔌',
  CONTEXT: '⚙️',
  IFRAME: '🌐',
  CHANNEL: '📡',
  AUTH: '🔐',
  KEYS: '🔑',
  COMPLETE: '✅',
}

const STATUS_ICONS = {
  START: '🔵',
  SUCCESS: '🟢',
  ERROR: '🔴',
  WARN: '🟡',
  SENT: '📤',
  RECEIVED: '📥',
  NEXT: '➡️',
}

function canUseWindow() {
  return typeof window !== 'undefined'
}

export function isPinpadFlowLoggingEnabled() {
  const envValue = process.env.REACT_APP_PINPAD_FLOW_LOGS_ENABLED
  if (envValue === 'false') {
    return false
  }

  if (!canUseWindow()) {
    return true
  }

  if (typeof window[FLOW_LOGS_ENABLED_GLOBAL_KEY] === 'boolean') {
    return window[FLOW_LOGS_ENABLED_GLOBAL_KEY]
  }

  const storageValue = window.localStorage
    ? window.localStorage.getItem(FLOW_LOGS_ENABLED_STORAGE_KEY)
    : null
  if (storageValue === '0' || storageValue === 'false') {
    return false
  }

  return true
}

export function setPinpadFlowLoggingEnabled(enabled) {
  if (!canUseWindow()) {
    return
  }

  window[FLOW_LOGS_ENABLED_GLOBAL_KEY] = !!enabled
  if (window.localStorage) {
    window.localStorage.setItem(FLOW_LOGS_ENABLED_STORAGE_KEY, enabled ? '1' : '0')
  }
}

export function getPinpadFlowId() {
  if (!canUseWindow()) {
    return 'NO_WINDOW'
  }

  return window[FLOW_ID_GLOBAL_KEY] || 'NO_FLOW_ID'
}

export function startPinpadFlow(initialData = {}) {
  const flowId = `FLOW-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`

  if (canUseWindow()) {
    window[FLOW_ID_GLOBAL_KEY] = flowId
  }

  logFlowStep({
    phase: 'INIT',
    step: 'Manual flow created',
    stepNumber: 0,
    status: 'START',
    data: initialData,
  })

  return flowId
}

export function logFlowStep({
  phase,
  step,
  stepNumber,
  status,
  data = {},
  error = null,
  duration = null,
  maxSteps = DEFAULT_MAX_STEPS,
}) {
  if (!isPinpadFlowLoggingEnabled()) {
    return null
  }

  const flowId = getPinpadFlowId()
  const phaseIcon = PHASE_ICONS[phase] || '⚪'
  const statusIcon = STATUS_ICONS[status] || '⚪'
  const prefix = `[PINPAD-FLOW-${flowId}] [${stepNumber}/${maxSteps}] ${phaseIcon} ${statusIcon}`
  const message = `${phase} → ${status} | ${step}`

  const payload = {
    flowId,
    phase,
    step,
    stepNumber,
    maxSteps,
    status,
    timestamp: new Date().toISOString(),
    ...(duration !== null ? { duration } : {}),
    ...(Object.keys(data).length ? { data } : {}),
    ...(error ? { error } : {}),
  }

  if (status === 'ERROR') {
    console.error(`${prefix} ${message}`, payload)
  } else if (status === 'WARN') {
    console.warn(`${prefix} ${message}`, payload)
  } else {
    console.log(`${prefix} ${message}`, payload)
  }

  return payload
}
